import React, { useEffect, useState } from 'react'
import { Button, Input, Pagination as AntPagination, Table, Select } from 'antd'

import { SearchOutlined } from '@ant-design/icons'
import { GrFormClose } from 'react-icons/gr'
import { GiHockey } from 'react-icons/gi'

// Component
import MainHeader from '../components/MainHeader'
import PlayerDetailsModal from '../components/modal/PlayerDetailsModal'

import { createAuction, getFreeAgent } from '../redux/actions/rosterAction'
import { useNavigate } from 'react-router-dom'
import { getAge, getRankAndPosition } from '../config/helperFunctions'

import { useDispatch } from 'react-redux'
import { openModal } from '../redux/actions/interfaceModalActions'

const FreeAgent = () => {
  const [freeAgents, setFreeAgents] = useState({
    total: 0,
    players: [],
  })
  const [loading, setLoading] = useState(true)
  const [playerID, setPlayerID] = useState(false)
  const [limit] = useState(10)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [filterBy, setFilterBy] = useState('')

  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    getData()
  }, [page, filterBy])

  const getData = async () => {
    window.scrollTo({
      top: 200,
      left: 0,
      behavior: 'smooth',
    })
    setLoading(true)
    const res = await getFreeAgent({
      search,
      limit: limit,
      page: page,
      sort: filterBy,
    })
    setFreeAgents(res)
    setLoading(false)
  }

  const handlePagination = (val) => setPage(val)

  const handleFilterBy = async () => {
    setLoading(true)
    if (search?.trim() !== '') {
      const res = await getFreeAgent({
        search,
        limit: limit,
        page: 1,
        sort: '',
      })
      setFreeAgents(res)
    }
    setLoading(false)
  }

  const onFieldClear = async () => {
    setLoading(true)
    const res = await getFreeAgent({
      search: '',
      limit: limit,
      page: 1,
      sort: '',
    })
    setFreeAgents(res)
    setLoading(false)
  }

  const handleCreateAuction = async (playerID, player_id) => {
    setPlayerID(playerID)
    const res = await createAuction({
      PlayerID: playerID,
      player_id: player_id,
      auctionFrom: 'nonowner',
    })
    if (res) {
      navigate('/player-auction')
    }
    setPlayerID('')
  }

  const columns = [
    {
      title: ' ',
      dataIndex: 'HostedHeadshotNoBackgroundUrl',
      key: 'HostedHeadshotNoBackgroundUrl',
      render: (text) => {
        return (
          <div className='squad_image_box'>
            {text ? <img src={text} alt={'Player'} /> : <GiHockey size={45} color={'#c4c4c4'} />}
          </div>
        )
      },
    },
    {
      title: 'POSITION',
      dataIndex: 'Position',
      key: 'Position',
    },
    {
      title: 'PLAYER NAME',
      dataIndex: 'Name',
      key: 'Name',
      render: (t, obj) => {
        return (
          <span
            className='fa_p_name name_text_hover'
            onClick={() => {
              dispatch(
                openModal({
                  playerID: obj?.PlayerID,
                  teamId: null,
                  teamName: '',
                  teamLogo: null,
                  isFreeAgent: true,
                }),
              )
            }}
          >
            {t}
          </span>
        )
      },
    },
    {
      title: 'PF',
      dataIndex: 'pf',
      key: 'pf',
      render: (t) => {
        return <p>{t > 0 ? t : '-'}</p>
      },
    },
    {
      title: 'AVG PF',
      dataIndex: 'avgPf',
      key: 'avgPf',
      render: (t) => <p>{t > 0 ? t : '-'}</p>,
    },
    {
      title: 'PLAYER RANK',
      dataIndex: 'playerRank',
      key: 'playerRank',
      render: (_, obj) => <p>{getRankAndPosition(obj?.dailyScoring)?.playerOverallRank}</p>,
    },

    {
      title: 'AGE',
      dataIndex: 'BirthDate',
      key: 'BirthDate',
      render: (t) => <p>{getAge(t) || '-'}</p>,
    },
    {
      title: 'TEAM',
      dataIndex: 'Team',
      key: 'Team',
      render: (t) => <p>{t || '-'}</p>,
    },
    {
      title: 'OPP',
      dataIndex: 'Opponent',
      key: 'Opponent',
      render: (t) => <p>{t || '-'}</p>,
    },
    {
      title: 'PLAYER CAP #',
      dataIndex: 'PlayerCap',
      key: 'PlayerCap',
      render: (t) => <p> {t ? `$${t?.toLocaleString()}` : '-'}</p>,
    },

    {
      title: ' ',
      dataIndex: 'auction',
      key: 'auction',
      render: (_, obj) => {
        return (
          <Button
            disabled={false}
            loading={playerID == obj?.PlayerID}
            type='primary'
            className='_button'
            onClick={() => {
              handleCreateAuction(obj?.PlayerID, obj?._id)
            }}
          >
            Auction
          </Button>
        )
      },
    },
  ]

  return (
    <div className='practice_squad_container team_trade_main'>
      <MainHeader headingAndDate={false} />

      <section className='squad_card_container transparent'>
        <div className='header'>
          <div className='heading_selectBox'>
            <h2>FREE AGENT</h2>
            <Select
              placeholder='Sort by'
              onChange={(v) => setFilterBy(v)}
              allowClear={{ clearIcon: <GrFormClose size={25} onClick={() => {}} /> }}
              options={[
                {
                  value: 'pf_asc',
                  label: 'Total PF Ascending',
                },
                {
                  value: 'pf_desc',
                  label: 'Total PF Descending',
                },
                {
                  value: 'apf_asc',
                  label: 'Average PF Ascending',
                },
                {
                  value: 'apf_desc',
                  label: 'Average PF Descending',
                },
              ]}
              className='filter_select_box'
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Input
              className='free_agent_search_input'
              size='small'
              placeholder='Search here...'
              prefix={<SearchOutlined />}
              onChange={(e) => {
                setSearch(e.target.value)
                if (e.target.value === '') {
                  onFieldClear()
                }
              }}
              allowClear={{ clearIcon: <GrFormClose size={25} onClick={onFieldClear} /> }}
            />
            <Button className='_transparent_button' type='primary' onClick={handleFilterBy}>
              SEARCH
            </Button>
          </div>
        </div>

        <div className='new_table_container'>
          <Table
            loading={loading}
            dataSource={freeAgents?.players}
            columns={columns}
            bordered={false}
            pagination={false}
            scroll={{ x: 1100 }}
            rowKey='_id'
          />
        </div>
        <div className='custom_pagination_box pagination_box'>
          <AntPagination
            defaultCurrent={page}
            total={freeAgents?.total}
            showSizeChanger={false}
            onChange={handlePagination}
            pageSize={limit}
          />
        </div>
      </section>

      <PlayerDetailsModal />
    </div>
  )
}

export default FreeAgent
